import {
  GearIcon,
  SpeedFast,
  SpeedMedium,
  SpeedSlow,
} from '@root/shared/ui-kit'

import type { SuggestedGasSettings } from '../model'
import type { IconProps } from '@root/shared/ui-kit'

type GasSettingsVariantIconProps = IconProps & {
  variant: SuggestedGasSettings.SettingVariant | 'advanced'
}

export const GasSettingVariantIcon: React.FC<GasSettingsVariantIconProps> = ({
  variant,
  ...iconProps
}) => {
  const Icon = GAS_VARIANT_ICON_MAP[variant]
  return <Icon {...iconProps} />
}

const GAS_VARIANT_ICON_MAP: Record<
  SuggestedGasSettings.SettingVariant | 'advanced',
  React.FC<IconProps>
> = {
  high: SpeedFast,
  market: SpeedMedium,
  low: SpeedSlow,
  advanced: GearIcon,
}
